import { createContext, useContext } from 'react';

export const notificationsContext = createContext<{ unreadCount: number }>({
  unreadCount: 0,
});

export const useNotificationContext = () => useContext(notificationsContext);
